import { SidebarConnectivityStatus } from '@affine/core/modules/app-sidebar/views';
import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { WorkspacePermissionService } from '@affine/core/modules/permissions';
import {
  openStoragePlans,
  WorkspaceQuotaService,
} from '@affine/core/modules/quota';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

/** The rail's connectivity status with the workspace's sync pause. */
export const WorkspaceConnectivityStatus = () => {
  const storageFull = useLiveData(
    useService(WorkspaceQuotaService).storageFull$
  );
  const isOwner = useLiveData(
    useService(WorkspacePermissionService).permission.isOwner$
  );
  const workspaceDialogService = useService(WorkspaceDialogService);
  const openPlans = useCallback(
    () => openStoragePlans(workspaceDialogService),
    [workspaceDialogService]
  );
  return (
    <SidebarConnectivityStatus
      onOpenPlans={isOwner ? openPlans : undefined}
      placement="rail-avatar"
      storageFull={storageFull}
    />
  );
};
